import React from "react";


import {
    PageContainerComponent
} from "@Components/Sections";

import {
    SupportSectionComponent
} from "@Parts/@Support";

import {
    HeadSectionComponent,
} from "@Parts/Sections";


import headImage from "./@Images/headImage.svg";


import "./index.scss";


import FAQPageQuestionListSection from "@Pages/FAQ/QuestionList";




export const FAQPage:React.FC = () => {

    return (
        <PageContainerComponent pageType={'faq-page'}>

            <HeadSectionComponent
                pageName={'faq-page'}
                sectionHeaderText={'Frequently Asked Questions'}
                sectionSubText={'Everything you need to know about Qyvo\'s automatic<br/> refund service'}
                sectionImage={headImage}
            />

            <FAQPageQuestionListSection />

            <SupportSectionComponent />

        </PageContainerComponent>
    );

};


export default FAQPage;
